module.exports = __webpack_public_path__ + "static/media/bg-desk-spacer.e6446f10.svg";